<template>
  <router-view></router-view>
</template>

<script>
// import "./assets/Fonts/Amiri/Amiri-Regular-normal";

export default {
  async beforeCreate() {},
  async created() {
    await this.$store.dispatch("global/fetchProfile");
    await this.$store.dispatch("global/fetchGlobalEmployeesApi");
    await this.$store.dispatch("global/fetchCompanyInfo");
  },
};
</script>




<style lang="scss">
.selection.dropdown {
  border: none !important;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15) !important;
}

.md-field.md-theme-default {
  margin-top: 0 !important;
}

.md-layout-item-time {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}

.md-layout-item-time-custom {
  margin-top: 6px !important;
}

.md-layout-item-time .monthly-picker .flexbox {
  flex-direction: row-reverse !important;
}

.md-layout-item-time .monthly-picker {
  margin-top: -4px;
}

.monthly-picker-head {
  position: absolute;
  z-index: 1;
  top: -15px;
  font-size: 15px;
}

.monthly-picker-head.active {
  top: -35px;
  font-size: 13px;
}

.monthly-picker {
  position: absolute;
  width: 100%;
}
.monthly-picker .month-year-display {
  border: 0 !important;
  box-shadow: none !important;
  border-bottom: 1px solid !important;
  border-color: #d9d9d9 !important;
}

.date-popover.visible {
  max-width: 100% !important;
}

.input-must-rtl {
  display: flex !important;
  min-height: 2.71428571em !important;
  padding-right: 0 !important;
}
.input-must-rtl .dropdown.icon {
  left: 0 !important;
  right: initial !important;
}
.input-must-rtl .text.default {
  left: 0 !important;
  /* right: -25px !important; */
  color: #000 !important;
}

.input-must-rtl .search {
  padding-right: 0 !important;
}

.input-must-rtl .menu .item {
  text-align: right !important;
}

.md-datepicker.md-focused label {
  margin-right: 0 !important;
}

.md-datepicker.md-has-value label {
  margin-right: 0 !important;
}

/* vue-ctk-date-time-picker */

.pickers-container .flex {
  direction: ltr;
}

.date-time-picker .flex {
  display: -webkit-box;
  display: -ms-flexbox;
  /* display: flex; */
}

.field.has-value:not(.no-label) .field-input[data-v-5b500588] {
  padding-top: 0px;
}

.field.has-value .field-label[data-v-5b500588] {
  opacity: 0;
}

.custome-text-align {
  .md-table-head-container {
    text-align: right !important;
  }
  .md-table-cell-container {
    text-align: right !important;
  }
}

@media (max-width: 1199.98px) {
  .md-layout-item {
    min-width: 45% !important;
    margin-top: 20px !important;
  }
}

.md-field {
  .md-icon-button {
    z-index: 1 !important;
  }
}
</style>
